<template lang="pug">
.col-sm-12.col-lg-3.mb-3.order-2.order-lg-3.sidebar_search
    button.d-lg-none.btn.btn-primary.rounded-0.w-100.text-uppercase.font-weight-bold(@click.prevent="initShowFilter()", ref='toggleFiltreButton') {{ this.showAllFilter ? 'Cacher les fitres' : 'Afficher les filtres'}}
    .card.rounded-0.tf_card(v-show='showAllFilter')
        .card-body
            .mes_filtre(v-show='saveFilter.length > 0')
                h5(@click.prevent="showMyFilters = !showMyFilters")
                    | Mes filtres
                    span.float-right.cursor-pointer
                      i.fa.fa-caret-down.text-secondary
                .in.show#mes_filtre(v-show='showMyFilters')
                  ul.list-unstyled
                    li.clearfix(v-for="(filter,index) in saveFilter" :key='filter.id')
                      .custom-control.custom-checkbox.d-inline-block.mr-2
                        input.custom-control-input(type='checkbox', :value='filter.nom', :id="'filtre-' + index", :checked='filter.checked', @click.prevent='handleFilterClick(filter, $event)')
                        label.custom-control-label(:for="'filtre-' + index") {{filter.nom}}
                      button.btn.btn-link.float-right.p-0(@click.prevent='removeFilter(index)')
                        i.fa.fa-times-circle.fa-x2
                hr
            .mot_cle
                h5(@click.prevent="showKeyWord = !showKeyWord")
                    | Mot clé
                    span.float-right.cursor-pointer
                      i.fa.fa-caret-down.text-secondary
                .in.show(v-show="showKeyWord")
                    .input-group.mb-0
                        input.form-control.rounded-0(type='text', placeholder='Mot clé' v-model='searchText')
                    .submit
                        button.btn.btn-primary.rounded-0.w-100.text-uppercase.font-weight-bold(role="button", @click.prevent="search(true)" :disabled="!canSearch") rechercher
                hr
            .code
              h5(@click.prevent="showCode = !showCode")
                | Code
                span.float-right.cursor-pointer
                  i.fa.fa-caret-down.text-secondary
              .in.show(v-show="showCode")
                .input-group.mb-0
                  input.form-control.rounded-0(type='text', placeholder='Code' v-model='searchCode')
              hr
            .statuts
              h5(@click.prevent="showStatus = !showStatus")
                  | STATUTS
                  span.float-right.cursor-pointer
                    i.fa.fa-caret-down.text-secondary
              .in.show(v-show="showStatus")
                  .row
                      .status.mb-2.col-md-12
                          ul.list-unstyled
                            li(v-for='(statut, index) in getStatuts' :key='statut.id')
                              .custom-control.custom-checkbox.d-inline-block.mr-2
                                input.custom-control-input(:id="`statut-${index}`", type='checkbox' v-model='searchStatut' :value='statut.id')
                                label.custom-control-label(:for="`statut-${index}`") {{ statut.label }}
            .Type.mb-2
                hr
                h5(@click.prevent="showType = !showType")
                    | TYPE
                    span.float-right.cursor-pointer
                      i.fa.fa-caret-down.text-secondary
                .in.show#type(v-show="showType")
                    ul.list-unstyled
                      li(v-for='(type, index) in getTypes' :key='type.id')
                        .custom-control.custom-checkbox.d-inline-block.mr-2
                          input.custom-control-input(:id="`type-${index}`", type='checkbox' v-model='searchType' :value='type.id')
                          label.custom-control-label(:for="`type-${index}`") {{ type.label }}
            .wilaya
                hr
                h5(@click.prevent="showWilaya = !showWilaya")
                    | wilaya
                    span.float-right.cursor-pointer
                      i.fa.fa-caret-down.text-secondary
                .in.show(v-show="showWilaya")
                    ul.list-unstyled.scroll-filtre(v-show='getWilaya.length > 0')
                        li(v-for="(wilaya,index) in getWilaya" :key="wilaya.id")
                          .custom-control.custom-checkbox.d-inline-block.mr-2
                              input.custom-control-input(:id="'wilaya-' + index", type='checkbox' v-model='searchWilaya', :value='wilaya')
                              label.custom-control-label(:for="'wilaya-' + index") {{wilaya.text}}
                    .input-group.mb-0
                        input.form-control.rounded-0(type='text', placeholder='Recherche par wilaya' v-model='filterWilaya')
            .annonceur
                hr
                h5(@click.prevent="showAnnonceur = !showAnnonceur")
                    | Annonceur
                    span.float-right.cursor-pointer
                      i.fa.fa-caret-down.text-secondary
                #tf_annonceur.my-2.clearfix(v-show="showAnnonceur")
                    //.input-group
                      // el-autocomplete.form-control(v-model='query.annonceur', :fetch-suggestions='querySearchAsync', valueKey='nom' placeholder='Annonceur', @select='handleSelectAnnonceur' :debounce='600')
                    //<v-select multiple v-model='searchAnnonceur' label='nom' :debounce='250' :on-search='getOptions' :options='annonceurs'></v-select>
                    el-autocomplete.my-2.clearfix(v-model='query.annonceur', :fetch-suggestions='querySearchAsync', valueKey='nom' placeholder='Recherche Par Annonceur', @select='handleSelectAnnonceur', :debounce='600', popper-class='annonceurs-suggestions')
                    ul.list-unstyled.scroll-filtre
                      li(v-for="(annonceur,index) in searchAnnonceur")
                        .custom-control.custom-checkbox.d-inline-block.mr-2
                          input.custom-control-input(:id="'annonceur-' + index", type='checkbox' v-model='searchAnnonceur', :value='annonceur')
                          label.custom-control-label(:for="'annonceur-' + index") {{annonceur.nom}}
            .secteurs.mb-2
                hr
                h5(@click.prevent="showSecteur = !showSecteur")
                    | Secteurs
                    span.float-right.cursor-pointer
                      i.fa.fa-caret-down.text-secondary
                #secteurs.my-2.clearfix(v-show="showSecteur")
                    ul.list-unstyled.scroll-filtre
                      li(v-for="(secteur,index) in getSecteurs" :key='secteur.id')
                        .custom-control.custom-checkbox.d-inline-block.mr-2
                            input.custom-control-input(:id="'secteur-' + index", type='checkbox' v-model='searchSecteur', :value='secteur')
                            label.custom-control-label(:for="'secteur-' + index") {{secteur.text}}
                    .input-group.mb-0
                        input.form-control.rounded-0(type='text', placeholder='Recherche par secteur' v-model='filterSecteur')
            .date
                hr
                h5.mt-3(@click.prevent="showDatep = !showDatep")
                    | Date Publication
                    span.float-right.cursor-pointer
                      i.fa.fa-caret-down.text-secondary
                #debut(v-show="showDatep")
                    .row
                        .col-12
                          ul.list-unstyled
                            li.clearfix
                                .custom-control.custom-checkbox.d-inline-block.mr-2
                                  input.custom-control-input(type='checkbox' v-model='datePub', value='Day', id='Day', @click='setDatePublication("start", "day", $event)', ref="pubDay")
                                  label.custom-control-label(for='Day') Aujourd’hui
                            li.clearfix
                                .custom-control.custom-checkbox.d-inline-block.mr-2
                                  input.custom-control-input(type='checkbox', v-model='datePub', value='Week', id='Week', @click='setDatePublication("start", "week", $event)', ref="pubWeek")
                                  label.custom-control-label(for='Week') Cette semaine
                            li.clearfix
                                .custom-control.custom-checkbox.d-inline-block.mr-2
                                  input.custom-control-input(type='checkbox' v-model='datePub', value='Month', id='Month', @click='setDatePublication("start", "month", $event)', ref="pubMonth")
                                  label.custom-control-label(for='Month') Ce mois
                            li.clearfix
                                .custom-control.custom-checkbox.d-inline-block.mr-2
                                  input.custom-control-input(type='checkbox' v-model='datePub', value='Custom', id='Custom', @click='setDatePublication("start", "custom", $event)', ref="pubCustom")
                                  label.custom-control-label(for='Custom') Personaliser
                        .col-12(v-show="datePub[0] === 'Custom'")
                            .input-group.my-2
                                el-date-picker(v-model='datePublication', type='daterange', align='left', range-separator='-', start-placeholder='Du', end-placeholder='Au', format='dd/MM/yyyy', :editable='false', @change='handleCustomDatePublication')
                hr.clearfix
                h5.mt-3(@click.prevent="showDatef = !showDatef")
                    | Date Fin
                    span.float-right.cursor-pointer
                      i.fa.fa-caret-down.text-secondary
                #fin(v-show="showDatef")
                    .row
                        .col-12
                          ul.list-unstyled
                            li.clearfix
                                .custom-control.custom-checkbox.d-inline-block.mr-2
                                  input.custom-control-input(type='checkbox' v-model='dateFin', value='Day', id='todayfin', @click='setDatePublication("end", "day", $event)')
                                  label.custom-control-label(for='todayfin') Aujourd’hui
                            li.clearfix
                                .custom-control.custom-checkbox.d-inline-block.mr-2
                                  input.custom-control-input(type='checkbox' v-model='dateFin', value='Week', id='weekfin', @click='setDatePublication("end", "week", $event)')
                                  label.custom-control-label(for='weekfin') Cette semaine
                            li.clearfix
                                .custom-control.custom-checkbox.d-inline-block.mr-2
                                  input.custom-control-input(type='checkbox' v-model='dateFin', value='Month', id='monthfin', @click='setDatePublication("end", "month", $event)')
                                  label.custom-control-label(for='monthfin') Ce mois
                            li.clearfix
                                .custom-control.custom-checkbox.d-inline-block.mr-2
                                  input.custom-control-input(type='checkbox' v-model='dateFin', value='Custom', id='customfinfin', @click='setDatePublication("end", "custom", $event)')
                                  label.custom-control-label(for='customfinfin') Personaliser
                        .col-12(v-show="dateFin[0] === 'Custom'")
                            .input-group.my-2
                                el-date-picker(v-model='dateEcheance', type='daterange', align='left', unlink-panels='', range-separator='-', start-placeholder='Du', end-placeholder='Au', format='dd/MM/yyyy', @change='handleCustomDateFin')
                hr.clearfix
                .in.show
                  .submit
                      button.btn.btn-primary.rounded-0.w-100.text-uppercase.font-weight-bold(role="button", @click.prevent="search(true)", :disabled="!canSearch") rechercher
</template>

<script>
import Vue from 'vue'
import vSelect from 'vue-select'
import {isEqual} from 'lodash-es'
import EventBus from '../eventBus'
import {DatePicker, Select, Option, Autocomplete} from 'element-ui'
import lang from 'element-ui/lib/locale/lang/fr'
import locale from 'element-ui/lib/locale'
import moment from 'moment'
import Vuex from 'vuex'
global.v = Vuex
locale.use(lang)
Vue.use(DatePicker)
Vue.use(Select)
Vue.use(Option)
Vue.use(Autocomplete)
export default {
  data () {
    return {
      unwatch: null,
      showMyFilters: true,
      innerWidth: null,
      canSearch: true,
      showAllFilter: true,
      baseFilter: {
        searchText: '',
        searchCode: '',
        searchStatut: [],
        searchType: [],
        searchWilaya: [],
        searchAnnonceur: [],
        searchSecteur: [],
        datePublication: {
          type: null,
          start: null,
          end: null
        },
        dateEcheance: {
          type: null,
          start: null,
          end: null
        }
      },
      storeSubscriber: null,
      allWilayas: false,
      showfiltre: true,
      showStatus: true,
      showKeyWord: true,
      showCode: true,
      showType: true,
      showWilaya: true,
      showAnnonceur: true,
      showSecteur: true,
      showDatef: true,
      showDatep: true,
      customfin: false,
      customPub: false,
      statuts: [
        {
          id: 'avis-appel-offre',
          label: 'Appel d\'offres'
        },
        {
          id: 'prorogation-delai',
          label: 'Prorogation de délai'
        },
        {
          id: 'attribution-marche',
          label: 'Attribution de marché'
        },
        {
          id: 'annulation',
          label: 'Annulation'
        },
        {
          id: 'infructuosite',
          label: 'Infructuosité'
        },
        {
          id: 'vente-enchere',
          label: 'Vente aux enchères'
        },
        {
          id: 'adjudication',
          label: 'Adjudication'
        },
        {
          id: 'mise-demeure-information',
          label: 'Mise en demeure et résiliation'
        },
        {
          id: 'consultation',
          label: 'Consultation'
        }
      ],
      types: [
        {
          id: 'national',
          label: 'National'
        },
        {
          id: 'international',
          label: 'National & International'
        }
      ],
      wilayas: [],
      annonceurs: [],
      secteursActivites: [],
      datePublication: null,
      tmpCheckedFilters: [],
      dateEcheance: null,
      dateFin: [],
      datePub: [],
      filterWilaya: '',
      filterSecteur: '',
      d_selected: {},
      query: {
        annonceur: ''
      }
    }
  },
  components: {
    vSelect
  },
  mounted () {
    this.$nextTick(() => {
      setTimeout(() => {
        if (window.getComputedStyle(this.$refs.toggleFiltreButton).getPropertyValue('display') !== 'none') {
          this.showAllFilter = false
        }
      }, 250)
      window.addEventListener('orientationchange', this.orientationHandler)
      window.addEventListener('resize', this.resizeHandler)
    })
  },
  created () {
    this.unwatch = this.$watch('listeaosPagination.current_page', function () {
      this.search(false)
    })
    EventBus.$on('addNewFilter', (payload) => {
      const filter = this.setFilterDates(payload, true)
      this.setsaveFilter(filter)
    })
    this.storeSubscriber = this.$store.subscribe((mutation) => {
      if (mutation.type === 'CHECK_UNCHECK_FILTER') {
        switch (this.searchFilter.datePublication.type) {
          case null: this.datePub.shift()
            this.datePublication = null
            break
          case 'custom': this.datePub.push('Custom')
            this.datePublication = []
            this.datePublication[0] = moment(this.searchFilter.datePublication.start).toDate()
            this.datePublication[1] = moment(this.searchFilter.datePublication.end).toDate()
            break
          default: this.datePub.push(this.capitalizeFirstLetter(this.searchFilter.datePublication.type))
        }
        switch (this.searchFilter.dateEcheance.type) {
          case null: this.dateFin.shift()
            this.dateEcheance = null
            break
          case 'custom': this.dateFin.push('Custom')
            this.dateEcheance = []
            this.dateEcheance[0] = moment(this.searchFilter.dateEcheance.start).toDate()
            this.dateEcheance[1] = moment(this.searchFilter.dateEcheance.end).toDate()
            break
          default: this.dateFin.push(this.capitalizeFirstLetter(this.searchFilter.dateEcheance.type))
        }
        this.search(true)
      }
    })
    moment.locale('fr')
    const timeZone = (() => {
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
      if (typeof (timeZone) === 'undefined') {
        return null
      } else {
        return timeZone
      }
    })()
    if (timeZone === 'Africa/Algiers') {
      moment.updateLocale('fr', {
        week: {
          dow: 0
        }
      })
    }
    this.fetchInitialResults()
    // window.axios.get('/u/public/secteurs_activites')
    //   .then(response => {
    //     this.secteursActivites = response.data
    //   })
    // window.axios.get('/u/public/wilayas')
    //   .then(response => {
    //     this.wilayas = response.data
    //   })
    //   .catch(e => {
    //   })
    // window.axios.get('/u/public/annonceurs')
    //   .then(response => {
    //     this.annonceurs = response.data
    //     if (typeof this.$route.query.q !== 'undefined') {
    //       this.searchText = this.$route.query.q
    //     }
    //     if (typeof this.$route.query.annonceur !== 'undefined') {
    //       this.searchAnnonceur.push(this.annonceurs.filter((e) => e.id === parseInt(this.$route.query.annonceur))[0])
    //     }
    //     this.search()
    //     this.setFilterStore(false)
    //   })
    // if (this.isAuth & this.statusCompte === '') {
    //   window.axios.get('/u/saved-searches')
    //     .then(response => {
    //       const filters = response.data.map((filter) => this.setFilterDates(filter))
    //       filters.forEach((filter) => this.setsaveFilter(filter))
    //     })
    // }
  },
  beforeDestroy () {
    const links = ['prev', 'next', 'canonical']
    links.forEach(e => {
      const node = document.querySelector(`link[rel=${e}]`)
      if (node !== null) {
        node.parentNode.removeChild(node)
      }
    })
    window.removeEventListener('orientationchange', this.orientationHandler)
    window.removeEventListener('resize', this.resizeHandler)
    if (this.initRechercheAo === true) {
      const filter = Object.assign(this.activeFilter, {
        searchText: '',
        searchCode: '',
        searchStatut: [],
        searchType: [],
        searchWilaya: [],
        searchAnnonceur: [],
        searchSecteur: [],
        datePublication: {
          type: null,
          start: null,
          end: null
        },
        dateEcheance: {
          type: null,
          start: null,
          end: null
        }
      })
      this.updateActiveFilter(filter)
      this.updateSearchFilter(filter)
      this.setAppelOffrePage(1)
    }
    this.storeSubscriber()
    this.uncheckAllFilters()
    this.setdeleteFilterStore([])
    EventBus.$off('addNewFilter')
  },
  watch: {
    profilLoaded: function () {
      if (this.isAuth && this.canVieWAo() && this.profilLoaded && this.secteursActivites.length > 0 && typeof this.$route.query.annonceur === 'undefined' && typeof this.$route.query.c === 'undefined' && typeof this.$route.query.wilaya === 'undefined' && typeof this.$route.query.secteur === 'undefined') {
        const appelOffreService = this.profil.services.filter((e) => e.name === 'Appel Offre')
        if (appelOffreService.length > 0) {
          appelOffreService[0].options.secteurs.forEach((e) => {
            const secteur = this.secteursActivites.filter((x) => x.id === e)[0]
            this.searchSecteur.push(secteur)
          })
          this.search()
        } else {
          this.search()
        }
      }
      if (this.isAuth && !this.canVieWAo() && this.profilLoaded && this.secteursActivites.length > 0 && typeof this.$route.query.annonceur === 'undefined' && typeof this.$route.query.c === 'undefined' && typeof this.$route.query.wilaya === 'undefined' && typeof this.$route.query.secteur === 'undefined') {
        this.search()
      }
      if (!this.isAuth && this.secteursActivites.length > 0 && typeof this.$route.query.annonceur === 'undefined' && typeof this.$route.query.c === 'undefined' && typeof this.$route.query.wilaya === 'undefined' && typeof this.$route.query.secteur === 'undefined') {
        this.search()
      }
    },
    secteursActivites: function () {
      if (this.isAuth && this.canVieWAo() && this.profilLoaded && this.secteursActivites.length > 0 && typeof this.$route.query.annonceur === 'undefined' && typeof this.$route.query.c === 'undefined' && typeof this.$route.query.wilaya === 'undefined' && typeof this.$route.query.secteur === 'undefined') {
        const appelOffreService = this.profil.services.filter((e) => e.name === 'Appel Offre')
        if (appelOffreService.length > 0) {
          appelOffreService[0].options.secteurs.forEach((e) => {
            const secteur = this.secteursActivites.filter((x) => x.id === e)[0]
            this.searchSecteur.push(secteur)
          })
          this.search()
        } else {
          this.search()
        }
      }
      if (this.isAuth && !this.canVieWAo() && this.profilLoaded && this.secteursActivites.length > 0 && typeof this.$route.query.annonceur === 'undefined' && typeof this.$route.query.c === 'undefined' && typeof this.$route.query.wilaya === 'undefined' && typeof this.$route.query.secteur === 'undefined') {
        this.search()
      }
      if (!this.isAuth && this.secteursActivites.length > 0 && typeof this.$route.query.annonceur === 'undefined' && typeof this.$route.query.c === 'undefined' && typeof this.$route.query.wilaya === 'undefined' && typeof this.$route.query.secteur === 'undefined') {
        this.search()
      }
    },
    innerWidth: function (newWidth, oldWidth) {
      if (oldWidth !== newWidth && oldWidth !== null) {
        this.orientationHandler()
      }
    },
    searchFilter: {
      handler: function () {
        const sortedActiveFilter = this.sortFilterValues(JSON.parse((JSON.stringify(this.searchFilter))))
        const cleanSavedFilters = this.saveFilter.map((filter) => {
          const cleanedFilter = this.sortFilterValues(JSON.parse(JSON.stringify(filter)))
          delete cleanedFilter.checked
          delete cleanedFilter.nom
          delete cleanedFilter.id
          return cleanedFilter
        })
        cleanSavedFilters.forEach((filter, index) => {
          if (isEqual(sortedActiveFilter, filter)) {
            if (this.saveFilter[index].checked) {
              return true
            } else {
              this.shouldCheckFilter(index)
              this.updateActiveFilter(JSON.parse(JSON.stringify(this.searchFilter)))
              this.search()
            }
          } else {
            if (this.saveFilter[index].checked) {
              this.shouldUncheckFilter(index)
              this.updateActiveFilter(JSON.parse(JSON.stringify(this.baseFilter)))
              this.search()
            }
          }
        })
      },
      deep: true
    },
    searchWilaya: function (checkedWilayas) {
      this.allWilayas = checkedWilayas.length === 48
    },
    datePub: function (checked) {
      if (checked.length > 1) {
        this.datePub.shift()
      }
    },
    dateFin: function (checked) {
      if (checked.length > 1) {
        this.dateFin.shift()
      }
    },
    checkedFilters: function (value) {
      // this.tmpCheckedFilters = value
    }
  },
  computed: {
    ...Vuex.mapGetters(['profil', 'profilLoaded', 'saveFilter', 'listeaos', 'listeaosPagination', 'checkedFilters', 'activeFilter', 'searchFilter', 'isAuth', 'statusCompte', 'initRechercheAo']),
    getSecteurs () {
      const filteredSecteurs = this.filterNormalizedTerm(this.filterSecteur, this.secteursActivites)
      return this.sortArrayByCheckedArray(filteredSecteurs, this.searchSecteur)
    },
    getTypes () {
      return this.sortArrayByCheckedArrayValues(this.types, this.searchType)
    },
    getStatuts () {
      return this.sortArrayByCheckedArrayValues(this.statuts, this.searchStatut)
    },
    getWilaya () {
      const filteredWilaya = this.filterNormalizedTerm(this.filterWilaya, this.wilayas)
      return this.sortArrayByCheckedArray(filteredWilaya, this.searchWilaya)
    },
    checkedSavedFilter () {
      return this.saveFilter.filter((filter) => filter.checked)
    },
    searchText: {
      get () {
        return this.searchFilter.searchText
      },
      set (value) {
        const filter = Object.assign(this.searchFilter, {searchText: value})
        this.updateSearchFilter(filter)
      }
    },
    searchCode: {
      get () {
        return this.searchFilter.searchCode
      },
      set (value) {
        const filter = Object.assign(this.searchFilter, {searchCode: value})
        this.updateSearchFilter(filter)
      }
    },
    searchStatut: {
      get () {
        return this.searchFilter.searchStatut
      },
      set (value) {
        const filter = Object.assign(this.searchFilter, {searchStatut: value})
        this.updateSearchFilter(filter)
      }
    },
    searchType: {
      get () {
        return this.searchFilter.searchType
      },
      set (value) {
        const filter = Object.assign(this.searchFilter, {searchType: value})
        this.updateSearchFilter(filter)
      }
    },
    searchWilaya: {
      get () {
        return this.searchFilter.searchWilaya
      },
      set (value) {
        const filter = Object.assign(this.searchFilter, {searchWilaya: value})
        this.updateSearchFilter(filter)
      }
    },
    searchAnnonceur: {
      get () {
        return this.searchFilter.searchAnnonceur
      },
      set (value) {
        const filter = Object.assign(this.searchFilter, {searchAnnonceur: value})
        this.updateSearchFilter(filter)
      }
    },
    searchSecteur: {
      get () {
        return this.searchFilter.searchSecteur
      },
      set (value) {
        const filter = Object.assign(this.searchFilter, {searchSecteur: value})
        this.updateSearchFilter(filter)
      }
    }
  },
  methods: {
    changeTitle (title) {
      document.title = title
    },
    canVieWAo () {
      if (this.isAuth) {
        return this.profil.services.filter((x) => x.name === 'Appel Offre').length > 0
      }
      return false
    },
    changeMetaDescription (description) {
      const nodeDescription = document.querySelector('meta[name=description]')
      if (nodeDescription !== null) {
        nodeDescription.setAttribute('content', description)
        document.head.appendChild(nodeDescription)
      }
      const nodeOgDescription = document.querySelector('meta[property="og:description"]')
      if (nodeOgDescription) {
        nodeOgDescription.setAttribute('content', description)
        document.head.appendChild(nodeOgDescription)
      }
    },
    filterNormalizedTerm (term, array) {
      const normalizedTerm = term.replace(/[\u0300-\u036f]/g, '').toLowerCase().replace("'", '')
      return array.filter((item) => {
        const normalizedItem = item.text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace("'", '')
        return normalizedItem.indexOf(normalizedTerm) !== -1
      })
    },
    sortArrayByCheckedArrayValues (allArray, checkedArray) {
      return [...JSON.parse(JSON.stringify(allArray))].sort((a, b) => {
        if ((checkedArray.findIndex((e) => e === a.id) === -1 && checkedArray.findIndex((e) => e === b.id) === -1) ||
          (checkedArray.findIndex((e) => e === a.id) !== -1 && checkedArray.findIndex((e) => e === b.id) !== -1)) {
          // Aucun n'est coché ou les deux sont cochés
          return allArray.findIndex((e) => e === a.id) > allArray.findIndex((e) => e === b.id) ? 1 : -1
        } else {
          // un seul est coché
          return checkedArray.findIndex((e) => e === a.id) === -1 ? 1 : -1
        }
      })
    },
    sortArrayByCheckedArray (allArray, checkedArray) {
      return [...JSON.parse(JSON.stringify(allArray))].sort((a, b) => {
        if ((checkedArray.findIndex((e) => e.id === a.id) === -1 && checkedArray.findIndex((e) => e.id === b.id) === -1) ||
          (checkedArray.findIndex((e) => e.id === a.id) !== -1 && checkedArray.findIndex((e) => e.id !== b.id) === -1)) {
          // Aucun n'est coché ou les deux sont coché
          return a.id > b.id ? 1 : -1
        } else {
          // un seul est coché
          return checkedArray.findIndex((e) => e.id === a.id) === -1 ? 1 : -1
        }
      })
    },
    handleSelectAnnonceur (item) {
      const annonceurs = JSON.parse(JSON.stringify(this.searchAnnonceur))
      annonceurs.push({
        id: item.id,
        nom: item.nom
      })
      this.searchAnnonceur = annonceurs
      this.query.annonceur = ''
    },
    querySearchAsync (queryString, cb) {
      if (queryString.length <= 2) {
        // eslint-disable-next-line standard/no-callback-literal
        cb([])
      } else {
        window.axios.get(`/u/public/annonceurs/search?q=${this.query.annonceur}&ids=${this.searchAnnonceur.map((e) => e.id).join(',')}`)
          .then(response => {
            cb(response.data)
          })
      }
    },
    resizeHandler () {
      this.innerWidth = window.innerWidth
    },
    orientationHandler () {
      setTimeout(() => {
        if (window.getComputedStyle(this.$refs.toggleFiltreButton).getPropertyValue('display') !== 'none') {
          this.showAllFilter = false
        } else {
          this.showAllFilter = true
        }
      }, 200)
    },
    initShowFilter () {
      this.$refs.toggleFiltreButton.blur()
      this.showAllFilter = !this.showAllFilter
    },
    sortFilterValues (filter) {
      filter.searchStatut.sort()
      filter.searchType.sort()
      filter.searchWilaya = this.sortObjectById(filter.searchWilaya)
      filter.searchAnnonceur = this.sortObjectById(filter.searchAnnonceur)
      filter.searchSecteur = this.sortObjectById(filter.searchSecteur)
      return filter
    },
    sortObjectById (anObject) {
      return anObject.sort((a, b) => {
        if (a.id < b.id) return -1
        if (a.id > b.id) return 1
        return 0
      })
    },
    async fetchInitialResults () {
      const secteursActivitesPromise = window.axios.get('/u/public/secteurs_activites')
      const wilayasPromise = window.axios.get('/u/public/wilayas')
      const [secteursActivites, wilayas] = await Promise.all([secteursActivitesPromise, wilayasPromise])
      this.secteursActivites = secteursActivites.data
      // todo remove the slice once wilaya 59 has been removed from backend
      this.wilayas = wilayas.data.slice(0, -1)
      if (typeof this.$route.query.q !== 'undefined') {
        this.searchText = this.$route.query.q
      }
      if (typeof this.$route.query.c !== 'undefined') {
        const node = document.querySelector('meta[name=robots]')
        if (node !== null) {
          node.parentNode.removeChild(node)
        }
        this.searchCode = this.$route.query.c
      }
      if (typeof this.$route.query.wilaya !== 'undefined') {
        const node = document.querySelector('meta[name=robots]')
        if (node !== null) {
          node.parentNode.removeChild(node)
        }
        this.searchWilaya = this.wilayas.filter(wilaya => wilaya.id === parseInt(this.$route.query.wilaya))
        this.search()
      }
      if (typeof this.$route.query.secteur !== 'undefined') {
        const node = document.querySelector('meta[name=robots]')
        if (node !== null) {
          node.parentNode.removeChild(node)
        }
        this.searchSecteur = this.secteursActivites.filter(secteur => secteur.id === parseInt(this.$route.query.secteur))
        this.search()
      }
      if (typeof this.$route.query.annonceur !== 'undefined') {
        const node = document.querySelector('meta[name=robots]')
        if (node !== null) {
          node.parentNode.removeChild(node)
        }
        window.axios.get(`/u/public/annonceurs/${this.$route.query.annonceur}`)
          .then((r) => {
            this.searchAnnonceur = [r.data]
            const generiqueAnnonceurDescription = `Ensemble des ${this.listeaosPagination.total} appels d'offres émis par, `
            this.changeTitle(this.searchAnnonceur[0].nom)
            this.changeMetaDescription(generiqueAnnonceurDescription + this.searchAnnonceur[0].nom)
            this.search()
          })
          .catch(() => {
            // this.search(false, true)
          })
      } else {
        //  this.search(false, true)
      }
      this.setFilterStore(false)
      if (this.isAuth && this.statusCompte === '') {
        window.axios.get('/u/saved-searches')
          .then(response => {
            const filters = response.data.map((filter) => this.setFilterDates(filter))
            filters.forEach((filter) => this.setsaveFilter(filter))
            const tempsearchText = this.searchFilter.searchText ? this.searchFilter.searchText : 'a'
            // this.searchText = null
            if (tempsearchText !== this.searchFilter.searchText) {
              this.searchText = tempsearchText
              this.searchText = ''
            } else {
              this.searchText = ''
              this.searchText = tempsearchText
            }
          })
      }
    },
    setFilterDates (filtre, checked = false) {
      switch (filtre.datePublication.type) {
        case null:
          filtre.datePublication.start = null
          filtre.datePublication.end = null
          break
        case 'day':
        case 'week':
        case 'month':
          filtre.datePublication.start = moment().startOf(filtre.datePublication.type).format('YYYY-MM-DD')
          filtre.datePublication.end = moment().endOf(filtre.datePublication.type).format('YYYY-MM-DD')
          break
      }
      switch (filtre.dateEcheance.type) {
        case null:
          filtre.dateEcheance.start = null
          filtre.dateEcheance.end = null
          break
        case 'day':
        case 'week':
        case 'month':
          filtre.dateEcheance.start = moment().startOf(filtre.dateEcheance.type).format('YYYY-MM-DD')
          filtre.dateEcheance.end = moment().endOf(filtre.dateEcheance.type).format('YYYY-MM-DD')
      }
      filtre.checked = checked
      filtre.searchWilaya = filtre.searchWilaya.map((e) => {
        return this.wilayas.find((w) => w.id === e)
      })
      // filtre.searchAnnonceur = filtre.searchAnnonceur.map((e) => {
      //   return this.annonceurs.find((a) => a.id === e)
      // })
      filtre.searchSecteur = filtre.searchSecteur.map((e) => {
        return this.secteursActivites.find((s) => s.id === e)
      })
      return filtre
    },
    capitalizeFirstLetter (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    handleCustomDateFin (date) {
      const filter = date !== null ? Object.assign(this.searchFilter, {
        dateEcheance: {
          type: 'custom',
          start: moment(date[0]).format('YYYY-MM-DD'),
          end: moment(date[1]).format('YYYY-MM-DD')
        }}) : Object.assign(this.searchFilter, {
        dateEcheance: {
          type: null,
          start: null,
          end: null
        }})
      this.updateSearchFilter(filter)
    },
    handleCustomDatePublication (date) {
      const filter = date !== null ? Object.assign(this.searchFilter, {
        datePublication: {
          type: 'custom',
          start: moment(date[0]).format('YYYY-MM-DD'),
          end: moment(date[1]).format('YYYY-MM-DD')
        }}) : Object.assign(this.searchFilter, {
        datePublication: {
          type: null,
          start: null,
          end: null
        }})
      this.updateSearchFilter(filter)
    },
    handleFilterClick (filter) {
      this.checkUncheckFilter(filter)
    },
    setDatePublication (type, range, e) {
      const dataPropertyName = type === 'start' ? 'datePublication' : 'dateEcheance'
      this.$nextTick(function () {
        if (range === 'custom') {
          // The custom checkbox has been checked or unchecked
          this[dataPropertyName] = null
          const filter = Object.assign(this.searchFilter, {
            [dataPropertyName]: {
              type: null,
              start: null,
              end: null
            }})
          this.updateSearchFilter(filter)
        } else if (e.target.checked === true && range !== 'custom') {
          // A non custom checkbox has been checked
          // range can be day, week or month
          // this[dataPropertyName] = []
          // this[dataPropertyName][0] = moment().startOf(range).toDate()
          // this[dataPropertyName][1] = moment().endOf(range).toDate()
          this.datePublication = null
          const filter = Object.assign(this.searchFilter, {
            [dataPropertyName]: {
              type: range,
              start: moment().startOf(range).format('YYYY-MM-DD'),
              end: moment().endOf(range).format('YYYY-MM-DD')
            }})
          this.updateSearchFilter(filter)
        } else if (e.target.checked === false) {
          // A non custom checkbox has been unchecked
          this[dataPropertyName] = null
          const filter = Object.assign(this.searchFilter, {
            [dataPropertyName]: {
              type: null,
              start: null,
              end: null
            }})
          this.updateSearchFilter(filter)
        }
      })
    },
    loadFilter (data) {
      this.searchText = data.searchText
      this.searchCode = data.searchCode
      this.searchStatut = data.searchStatut
      this.searchType = data.searchType
      this.searchWilaya = data.searchWilaya
      this.searchAnnonceur = data.searchAnnonceur
      this.searchSecteur = data.searchSecteur
      this.datePublication = null
      if (data.fromDatePublication !== '') {
        const ref = 'pub' + data.fromDatePublication.type.charAt(0).toUpperCase() + data.fromDatePublication.type.substr(1)
        if (this.datePub.length > 0) {
          this.datePub.shift()
        }
        this.$nextTick(function () {
          this.$refs[ref].click()
          this.$nextTick(function () {
            this.search()
            return null
          })
        })
      } else {
        if (this.datePub.length > 0) {
          this.datePub.shift()
        }
      }
      this.dateEcheance = []
      if (data.fromDateFin !== 'none' & data.toDateFin !== 'none') {
        this.dateEcheance.push(data.fromDateFin)
        this.dateEcheance.push(data.toDateFin)
      }
      this.$nextTick(function () {
        this.search()
      })
    },
    initfilter () {
      this.searchText = ''
      this.searchCode = ''
      this.searchStatut = []
      this.searchType = []
      this.searchWilaya = []
      this.searchAnnonceur = []
      this.searchSecteur = []
      this.datePub.shift()
      this.datePublication = null
      this.dateEcheance = null
      this.search()
    },
    removeFilter (index) {
      window.axios.delete(`/u/saved-searches/${this.saveFilter[index].id}`)
        .then(response => {
          this.deleteSavedFilter(index)
          this.$notify({
            title: 'Supression de filtre',
            message: 'Filtre suprimé avec succes',
            type: 'success'
          })
        })
        .catch(e => {
        })
    },
    ...Vuex.mapActions({
      'setsearchStore': 'setsearch',
      'setFilterStore': 'setFilter',
      'setListAppelOffreStore': 'setListAppelOffre',
      'setdeleteFilterStore': 'setdeleteFilter',
      'deleteCheckedFilterStore': 'deleteCheckedFilter',
      'updateCheckedFilterStore': 'updateCheckedFilter',
      'setButtonFilterStore': 'setButtonFilter',
      'checkUncheckFilter': 'checkUncheckFilter',
      'updateActiveFilter': 'updateActiveFilter',
      'setAppelOffrePage': 'setAppelOffrePage',
      'updateSearchFilter': 'updateSearchFilter',
      'deleteSavedFilter': 'deleteSavedFilter',
      'shouldCheckFilter': 'shouldCheckFilter',
      'shouldUncheckFilter': 'shouldUncheckFilter',
      'uncheckAllFilters': 'uncheckAllFilters',
      'setsaveFilter': 'setsaveFilter',
      'setLoadTable': 'setLoadTable'
    }),
    w3cDate (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    search (resetPagination = false, secteurRestricted = false) {
      this.canSearch = false
      if (window.getComputedStyle(this.$refs.toggleFiltreButton).getPropertyValue('display') !== 'none') {
        this.showAllFilter = false
      }
      this.setLoadTable(true)
      this.updateActiveFilter(this.searchFilter)
      if (resetPagination) {
        // this.setFilterStore(true)
        this.setAppelOffrePage(1)
      }
      // this.setButtonFilterStore(true)
      window.axios.get('/u/public/appel-offres/', {
        params: {
          filter: this.activeFilter.searchText,
          code: this.activeFilter.searchCode,
          statut: this.activeFilter.searchStatut.join(),
          type: this.activeFilter.searchType.join(),
          wilaya: this.activeFilter.searchWilaya.map((wilaya) => wilaya.id).join(),
          annonceur: this.activeFilter.searchAnnonceur.map((annonceur) => annonceur.id).join(),
          secteurs: this.activeFilter.searchSecteur.map((secteur) => secteur.id).join(),
          from_date_publication: this.activeFilter.datePublication.start,
          to_date_publication: this.activeFilter.datePublication.end,
          from_date_fin: this.activeFilter.dateEcheance.start,
          to_date_fin: this.activeFilter.dateEcheance.end,
          page: this.listeaosPagination.current_page
        }
      })
        .then(response => {
          this.setListAppelOffreStore(response.data)
          this.setLoadTable(false)
          this.canSearch = true
          // Next link rel
          const nextURL = new URL(response.data.next_page_url)
          const nextPage = (new URLSearchParams(nextURL.search)).get('page')
          if (nextPage <= response.data.last_page) {
            const params = new URLSearchParams(new URL(window.location).search)
            params.set('page', nextPage)
            const node = document.querySelector('link[rel=next]')
            if (node !== null) {
              node.parentNode.removeChild(node)
            }
            const link = document.createElement('link')
            link.rel = 'next'
            link.href = `${window.location.origin}/listappeloffre/?${params.toString()}`
            document.getElementsByTagName('head')[0].appendChild(link)
          } else {
            const node = document.querySelector('link[rel=next]')
            if (node !== null) {
              node.parentNode.removeChild(node)
            }
          }
          // Prev link rel
          if (response.data.from > 1) {
            const prevURL = new URL(response.data.prev_page_url)
            const params = new URLSearchParams(new URL(window.location).search)
            const prevPage = (new URLSearchParams(prevURL.search)).get('page')
            params.set('page', prevPage)
            const node = document.querySelector('link[rel=prev]')
            if (node !== null) {
              node.parentNode.removeChild(node)
            }
            // add robot for other page except the first
            const nodeRobot = document.querySelector('meta[name=robots]')
            if (nodeRobot == null) {
              const meta = document.createElement('meta')
              meta.name = 'robots'
              meta.content = 'noindex, follow'
              document.getElementsByTagName('head')[0].appendChild(meta)
            }
            const link = document.createElement('link')
            link.rel = 'prev'
            link.href = `${window.location.origin}/listappeloffre/?${params.toString()}`
            document.getElementsByTagName('head')[0].appendChild(link)
          } else {
            const node = document.querySelector('link[rel=prev]')
            if (node !== null) {
              node.parentNode.removeChild(node)
            }
            const nodeRobot = document.querySelector('meta[name=robots]')
            if (nodeRobot !== null) {
              nodeRobot.parentNode.removeChild(nodeRobot)
            }
          }
          // canonical
          const canonicalPage = response.data.current_page
          const params = new URLSearchParams(new URL(window.location).search)
          params.set('page', canonicalPage)
          const node = document.querySelector('link[rel=canonical]')
          if (node !== null) {
            node.parentNode.removeChild(node)
          }
          const link = document.createElement('link')
          link.rel = 'canonical'
          link.href = `${window.location.origin}/listappeloffre/?${params.toString()}`
          document.getElementsByTagName('head')[0].appendChild(link)
          // change metadescription
          if (typeof this.$route.query.wilaya !== 'undefined') {
            this.changeTitle('Liste des annonces à ' + this.$route.query.wilaya + ' | Tendfox.com')
            const generiqueWilayaDescription = `Ensemble des ${this.listeaosPagination.total} appels d'offres et marchés publics et privés à, `
            this.changeMetaDescription(generiqueWilayaDescription + this.$route.query.wilaya)
          }
          if (typeof this.$route.query.secteur !== 'undefined') {
            this.changeTitle(this.$route.query.secteur)
            const generiqueDescription = `Ensemble des ${this.listeaosPagination.total} appels d'offres et marchés publics et privés émis par, `
            this.changeMetaDescription(generiqueDescription + this.$route.query.secteur)
            this.searchSecteur = this.secteursActivites.filter(secteur => secteur.text === this.$route.query.secteur)
          }
          if (typeof this.$route.query.annonceur !== 'undefined') {
            const generiqueAnnonceurDescription = `Ensemble des ${this.listeaosPagination.total} appels d'offres émis par, `
            this.changeTitle(this.searchAnnonceur[0].nom)
            this.changeMetaDescription(generiqueAnnonceurDescription + this.searchAnnonceur[0].nom)
          }
        })
        .catch(e => {
          // notif erreur
        })
    },
    getOptions (search, loading) {
      loading(true)
      window.axios.get('/admin/entreprises/search/?q=' + search + '&include=annonceur')
        .then(response => {
          this.annonceurs = response.data
          loading(false)
        })
    }
  }
}
</script>

<style lang="css" scoped>
.el-select {
    display: inline-block;
    position: relative;
    width: 100%;
}
.scroll-filtre {
    max-height: 190px;
    overflow-y: auto;
}

.el-autocomplete {
  position: relative;
  display: block;
}

.el-autocomplete >>> .el-input__inner {

  height: calc(2.1rem + 2px);
}
.el-autocomplete >>> .el-input__inner::placeholder {
  opacity: 1;
}
/*.el-autocomplete >>> .el-scrollbar {*/
/*  width: 100%;*/
/*}*/
</style>
<style>
.annonceurs-suggestions li:nth-child(2n+1) {
  background: #fff;
}

.annonceurs-suggestions li:nth-child(2n) {
  background: #f3f0eb;
}

.annonceurs-suggestions .el-autocomplete-suggestion__wrap {
  padding: 0;
}

.annonceurs-suggestions[x-placement^="bottom"] .popper__arrow::after {
  border-bottom-color: #f3f0eb;
}

</style>



// WEBPACK FOOTER //
// src/components/appeloffre/filtrerecherche.vue